import { Outlet, matchPath, useLocation } from 'react-router-dom-v5-compat';
import { pages } from 'common';
import Menu from '../Menu';
import { Page } from '@harvestiq/constants';

type MenuPage = Page;

type MenuItems = Record<string, MenuPage[]>;

// For it to display the "active" colors/classes the Header.tsx also needs to be modified
const menuItems: MenuItems = {
  quotes: [pages.lrpQuote, pages.lgmQuote],
  coverage: [pages.coverage, pages.watchlist],
  tools: [
    pages.breakevenCalculator,
    { ...pages.lgmQuoteScenarioAnalysis, title: 'LGM SCENARIO ANALYSIS' },
  ],
  more: [
    pages.faq,
    pages.contactUs,
    pages.privacyPolicy,
    pages.apply,
    pages.applyBusiness,
    pages.applyIndividual,
  ],
};

// list of pages that should not be shown in the menu but must determine the active category
const blacklist: MenuPage[] = [pages.applyBusiness, pages.applyIndividual];

const MenuRoutes = () => {
  const { pathname } = useLocation();

  const getActiveCategory = (): string | undefined => {
    for (const [category, items] of Object.entries(menuItems)) {
      if (items.some((item) => matchPath(pathname, item.path))) {
        return category;
      }
    }
    return undefined;
  };

  const activeCategory = getActiveCategory();

  const menuItemsFiltered = activeCategory
    ? menuItems[activeCategory].filter((item) => !blacklist.includes(item))
    : [];

  return (
    <div className="flex flex-1 flex-col width-100 flex-responsive pt-8 h-full">
      {activeCategory && (
        <Menu
          items={menuItemsFiltered}
          id={`${activeCategory}-menu`}
          className="flex flex-wrap !gap-4 justify-center mb-8"
          variant="outlined"
        />
      )}
      <Outlet />
    </div>
  );
};

export default MenuRoutes;
